"use strict"
import moment from "moment"

export function routeConfig(
  $urlRouterProvider,
  $locationProvider,
  $stateProvider,
  $mdGestureProvider,
  $mdDateLocaleProvider
) {
  "ngInject"

  $locationProvider.html5Mode(true)

  const getStateObject = (stateString) => {
    const viewString = `extrapanel@${stateString}`
    return {
      //
      // To lazy load a whole state of our app we need to add
      // a resolve method.
      url: "/manage",
      // url: "/map/:mapid/manage",
      // template: "<manage-panel></manage-panel>",
      // views: {
      //   "extrapanel@mainmap": "managepanel",
      // },
      views: {
        [viewString]: {
          template: "<manage-panel></manage-panel>",
        },
      },
      resolve: {
        // campsiteinfo: function (campsitedata) {
        //   return campsitedata
        // },
        // campsiteinfo: (dataService, $stateParams) => {
        // return dataService.getData($stateParams.mapid).then(function (response) {
        //   return response.data
        // })
        //   return dataService.getData($stateParams.mapid)
        // },
        lazyLoad($q, $ocLazyLoad) {
          "ngInject"

          let deferred = $q.defer()

          //
          // Async require => Split point
          require.ensure([], function () {
            //
            // All the code here, plus the required modules
            // will be bundled in a separate file.

            let module = require("./pages/managePanel/managePanel")

            //
            // OCLazyLoad's 'load' function loads the Angular module.
            $ocLazyLoad.load({
              name: module.default.name,
            })

            deferred.resolve(module)
          })

          return deferred.promise
        },
      },
      authenticate: "admin",
    }
  }

  $stateProvider.state("surroundings.manage", getStateObject("surroundings"))
  $stateProvider.state("mainmap.manage", getStateObject("mainmap"))

  $urlRouterProvider.otherwise("/home")

  // seems to fix problems with click events evident on firefox android
  $mdGestureProvider.skipClickHijack()

  $mdDateLocaleProvider.formatDate = function (date) {
    return moment(date).format("DD-MM-YYYY")
  }
}
